import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=891d012a&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('891d012a')) {
      api.createRecord('891d012a', component.options)
    } else {
      api.reload('891d012a', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=891d012a&", function () {
      api.rerender('891d012a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yMW197OtR46q/JS/comp/childrenage.vue"
export default component.exports